import type { ReactNode } from "react";

interface GamePanelProps {
  children: ReactNode;
  className?: string;
  tone?: "cosmic" | "gold" | "play";
}

const TONE_CLASS = {
  cosmic:
    "border-violet-300/25 bg-gradient-to-b from-indigo-900/85 to-violet-950/90 shadow-[0_8px_0_rgba(30,27,75,0.45)]",
  gold: "border-amber-200/30 bg-gradient-to-b from-amber-400/25 to-amber-600/20 shadow-[0_8px_0_rgba(120,53,15,0.35)]",
  play: "border-cyan-300/20 bg-gradient-to-b from-slate-900/75 to-indigo-950/85 shadow-[0_8px_0_rgba(15,23,42,0.45)]",
} as const;

export function GamePanel({ children, className = "", tone = "cosmic" }: GamePanelProps) {
  return (
    <div
      className={`game-panel rounded-3xl border-4 p-4 backdrop-blur-md ${TONE_CLASS[tone]} ${className}`}
    >
      {children}
    </div>
  );
}
